"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLocalhost = exports.signOut = exports.openAccountSettings = exports.openPersonalInformation = exports.makeRedirect = exports.handleRedirect = exports.authStatus = exports.signIn = void 0;
var auth_1 = require("../build-babel/auth");
var cookieBanner_1 = require("../build-babel/cookieBanner");
var config_1 = __importDefault(require("../build-babel/auth/client/config"));
require("../build-babel/css/azure-common.css");
require("../build-babel/css/azure-template.css");
require("../build-babel/css/azure-forms.css");
require("../build-babel/css/azure-forms-forgot-password.css");
require("../build-babel/form");
var redirect_1 = require("../build-babel/redirect");
var redirect_2 = require("../build-babel/redirect/redirect");
var session_1 = require("../build-babel/session");
var localhost_1 = require("../build-babel/redirect/localhost");
var aem_1 = require("../build-babel/aem");
var status_1 = require("../build-babel/auth/status");
var envDetector_1 = require("../build-babel/utils/envDetector");
var error_1 = require("../build-babel/logger/error");
var signIn = function signIn() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          (0, error_1.addErrorLogger)();
          if ((0, cookieBanner_1.shouldAddCookieConsentBanner)()) {
            (0, cookieBanner_1.addCookieConsentBanner)();
          }
          (0, redirect_1.setRedirectUrl)();
          _context.n = 1;
          return (0, auth_1.redirectToLogin)();
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
};
exports.signIn = signIn;
// might be injected as iFrame that posts login status to the parent via postMessage
var authStatus = function authStatus() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
    var authStatus;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return (0, auth_1.getCurrentAuthStatus)();
        case 1:
          authStatus = _context2.v;
          (0, status_1.onLoginStatusChange)(authStatus);
          // observe status change
          _context2.n = 2;
          return (0, auth_1.observeAuthStatus)(status_1.onLoginStatusChange);
        case 2:
          return _context2.a(2);
      }
    }, _callee2);
  }));
};
exports.authStatus = authStatus;
var handleRedirect = function handleRedirect() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
    var redirectUrl;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          redirectUrl = (0, redirect_1.getRedirectUrlParam)();
          if (!redirectUrl) {
            _context3.n = 1;
            break;
          }
          (0, redirect_2.makeRedirectTo)(redirectUrl);
          _context3.n = 2;
          break;
        case 1:
          _context3.n = 2;
          return (0, auth_1.redirectToLogin)();
        case 2:
          return _context3.a(2);
      }
    }, _callee3);
  }));
};
exports.handleRedirect = handleRedirect;
var makeRedirect = function makeRedirect() {
  var redirectUrl = (0, redirect_1.getRedirectUrl)();
  if (redirectUrl) {
    (0, redirect_2.makeRedirectTo)(redirectUrl);
  } else {
    var envConfig = (0, config_1["default"])();
    if (envConfig) {
      (0, redirect_2.makeRedirectTo)(envConfig.homepageUri);
    }
  }
};
exports.makeRedirect = makeRedirect;
var openPersonalInformation = function openPersonalInformation() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
    var envConfig;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          envConfig = (0, config_1["default"])();
          if (!envConfig) {
            _context4.n = 1;
            break;
          }
          _context4.n = 1;
          return (0, auth_1.redirectToAuthority)(envConfig.authorities.editProfile);
        case 1:
          return _context4.a(2);
      }
    }, _callee4);
  }));
};
exports.openPersonalInformation = openPersonalInformation;
var openAccountSettings = function openAccountSettings() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
    var envConfig;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          envConfig = (0, config_1["default"])();
          if (!envConfig) {
            _context5.n = 1;
            break;
          }
          _context5.n = 1;
          return (0, auth_1.redirectToAuthority)(envConfig.authorities.changePassword);
        case 1:
          return _context5.a(2);
      }
    }, _callee5);
  }));
};
exports.openAccountSettings = openAccountSettings;
var signOut = function signOut() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee6() {
    var envConfig, env, redirectUri;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          (0, session_1.removeSession)(window.location.href);
          envConfig = (0, config_1["default"])();
          if (!envConfig) {
            _context6.n = 2;
            break;
          }
          env = (0, envDetector_1.getEnv)(window.location.href);
          if (!env) {
            _context6.n = 1;
            break;
          }
          _context6.n = 1;
          return (0, aem_1.logoutFromAEM)(envConfig.aem.logoutAEMUri);
        case 1:
          redirectUri = (0, redirect_1.getRedirectUrl)() || (envConfig === null || envConfig === void 0 ? void 0 : envConfig.homepageUri);
          _context6.n = 2;
          return (0, auth_1.redirectToLogout)(redirectUri);
        case 2:
          return _context6.a(2);
      }
    }, _callee6);
  }));
};
exports.signOut = signOut;
var handleLocalhost = function handleLocalhost(env) {
  (0, redirect_1.setRedirectUrl)();
  var urlParams = new URLSearchParams(window.location.search);
  var action = urlParams.get('action');
  if (action && (env === 'deve' || env === 'qa')) {
    (0, localhost_1.handleLocalhostAction)(action, env);
    return;
  }
  var token = urlParams.get('token');
  (0, localhost_1.handleLocalhostToken)(token);
  var redirectUrl = (0, redirect_1.getRedirectUrl)();
  (0, redirect_1.removeRedirectUrl)();
  (0, redirect_2.makeRedirectTo)(redirectUrl || "".concat((0, localhost_1.getLocalhostBaseUrl)(), "/#/"));
};
exports.handleLocalhost = handleLocalhost;
//# sourceMappingURL=index.js.map